import { combineEpics } from 'redux-observable';
import { contactShareStatusesEpic } from './contacts';
import { groupShareStatusesEpic } from './groups';
import { ReduxAction } from '@repo/utils/types';
import AppState from '../../reducers/app-state';

export const shareStatusesEpics = combineEpics<ReduxAction, any, AppState>(
  contactShareStatusesEpic,
  groupShareStatusesEpic,
);
